import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Spinner,
  Select,
  Icon,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCircle,
  FaEdit,
  FaEye,
  FaFileExport,
  FaPlay,
  FaPlus,
  FaSearch,
  FaTrash,
} from "react-icons/fa";
import { FiCircle, FiEye, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../atoms/componentState";
import {
  BLACK,
  BLUEMONEDDBUTTONS,
  GRAY_DARK,
  GRAY_NEUTRAL,
  VARIANT,
  WHITE,
} from "../../../constants/colors";
import Pagination from "../../../defaultComponents/pagination";
import { goToAddVendaBoleto, goToDashboard } from "../../../routes/coordinator";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import SalesListAPI from "../../../services/SalesListApi";
// import ProfileDrawer from "../../menus/header/components/profileDrawer";
// import ClientApi from "../../../services/clientApi";
import {
  basicInfo,
  ClientInterface,
  statusInfo,
} from "../../../interfaces/defaultInterfaces";
import SystemApi from "../../../services/systemApi";
import ClientFilterSelect from "../../../defaultComponents/ClientFilterSelect";
import { LoggedUser } from "../../../atoms/userLogged";
// import ClientFilterSelect from "../../../defaultComponents/ClientFilterSelect";
import jwt_decode from "jwt-decode";
import ExtratoApi from "../../../services/ExtratoAPI";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import ValueDropdown from "../../../defaultComponents/valueDropdown";
import ModalSalesListDetail from "../listaDeVendas/components/modalSaleListDetail";
import ModalDetailVendaBoleto from "./components/ModalDetailVendaBoleto";

// interface objetoSalesList {
//   bandeira: {
//     bandeira: string;
//     id: number;
//   };
//   bandeiraCartao: string;
//   cartaoFim: string;
//   cartaoInicio: string;
//   clienteNome: string;
//   descricaoEC: string;
//   id: number;
//   cliente: ClientInterface;
//   idBandeira: string;
//   idCustomer: string;
//   idPos: string;
//   idPagamento: string;
//   idProvider: number;
//   idSeller: string;
//   idTransacao: string;
//   modoPagamento: string;
//   moeda: string;
//   numeroTransacao: string;
//   parcelas: number;
//   status: string;
//   taxaCliente: number;
//   taxaPlano: number;
//   taxaZoop: number;
//   taxas: number;
//   urlBoleto: string;
//   urlPIX: string;
//   valor: number;
//   valorLiquido: number;
//   valorOriginal: number;
//   dataCriacao: any;
//   dataExpiracao: string;
//   dataPagamento: any;
//   nomePagador: string;
//   estabelecimento: string;
// }

interface objetoSalesList {
  bandeira: string;
  bandeiraCartao: string;
  cartaoFim: string;
  cartaoInicio: string;
  clienteNome: string;
  cnpj: string;
  codigoAutorizacao: string;
  codigoAutorizacaoId: string;
  codigoNsu: string;
  dataAtualizacao: string;
  dataCriacao: string;
  dataEstorno: string;
  dataExpiracao: string;
  dataPagamento: string;
  dataReversao: string;
  nulldescricaoEC: string;
  id: number;
  idBandeira: number;
  idCliente: number;
  idCustomer: string;
  idModoPagto: number;
  idPOS: string;
  idPagamento: string;
  idProduto: number;
  idProjeto: number;
  idProvider: number;
  idSeller: string;
  idStatus: number;
  idTransacao: string;
  isCnpj: boolean;
  isCreditCard: boolean;
  modoPagamento: string;
  moeda: string;
  nome: string;
  nomeFantasia: string;
  nomeModoPgto: string;
  nomeProduto: string;
  nomeProjeto: string;
  numeroTransacao: string;
  parcelas: number;
  qrCodePIX: string;
  razaoSocial: string;
  reference_id: number;
  serialPOS: string;
  sobrenome: string;
  status: string;
  statusTransacao: string;
  taxaCliente: number;
  taxaPlano: number;
  urlBoleto: string;
  urlPIX: string;
  valor: number;
  valorLiquido: number;
  valorOriginal: number;
}

export interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
}

export default function SalesListBoleto() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<objetoSalesList>);
  const [itemDetails, setItemDetails] = useState<objetoSalesList>();
  const [isOpen, setIsOpen] = useState(false);

  const user = useRecoilState(LoggedUser)[0];
  const idUser = user.id;
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
  let dias = moment(dataFim).diff(dataInicio, "days") >= 32;
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 3,
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [details, setDetails] = useState({});
  const [openDetails, setOpenDetails] = useState(false);

  async function getSalesList() {
    try {
      setLoading(true);
      if (!search) {
        const response = await SalesListAPI.getSalesList(
          currentPage,
          pageSize,
          filtros.initialDateFilter,
          filtros.finalDateFilter,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          3
        );
        setSalesList(response.data);
        setPages(
          Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
        );
      } else {
        const response = await SalesListAPI.getSalesList(
          currentPage,
          pageSize,
          filtros.initialDateFilter,
          filtros.finalDateFilter,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          3
        );
        setSalesList(response.data);
        const lenght = response.data.length;
        setPages(Math.ceil(lenght / pageSize));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getSalesList();
    }
  }, [pages]);
  useEffect(() => {
    getSalesList();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    // filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
  }, []);
  const [clientList, setClientList] = useState(Array<ClientInterface>);
  const [statusList, setStatusList] = useState(Array<statusInfo>);
  const [modoPgtoList, setmodoPgtoList] = useState(Array<basicInfo>);

  async function Export() {
    try {
      setLoading(true);
      const response = await ExtratoApi.exportFile(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        "",
        filtros.saleTypeFilter,
        filtros.statusFilter
      );
      fileDownload(response, "relatorio.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getModoPgtoList() {
    try {
      const response = await SystemApi.getTransacoesModoPagamento();
      setmodoPgtoList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    // getClientList();
    getStatusList();
    getModoPgtoList();
  }, []);
  const clientOptions =
    clientList &&
    clientList.map((client) => {
      return {
        key: client.id,
        value: client.id,
        text:
          client?.isCnpj === true
            ? client?.razaoSocial
            : `${client.nome} ${client.sobrenome}`,
      };
    });
  const statusOptions =
    statusList &&
    statusList.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });
  const modoPgtoOptions =
    modoPgtoList &&
    modoPgtoList.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.nome,
      };
    });

  function onChangeClientFilter(e: any) {
    setFiltros({ ...filtros, clientFilter: Number(e.target.value) });
  }
  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }
  function onChangeModoPgtoFilter(e: any) {
    setFiltros({ ...filtros, saleTypeFilter: Number(e.target.value) });
  }

  console.log("filtros", filtros);

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Fazer uma venda no boleto
          </Text>
        </Flex>
        {/* <Flex px={8} py={3} my={4} alignItems="center">
          <Flex
            mr={4}
            border={`2px solid ${BLUEMONEDDBUTTONS}`}
            borderRadius={"6px"}
          >
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              Recebidos
            </Text>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              R$ 0,00
            </Text>
          </Flex>
          <Flex border={`2px solid ${BLUEMONEDDBUTTONS}`} borderRadius={"6px"}>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              A Receber
            </Text>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              R$ 0,00
            </Text>
          </Flex>
        </Flex>
        <Flex
          maxW={"53%"}
          px={8}
          py={3}
          my={4}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaPlus} />
            GERAR NOVO BOLETO
          </Button>
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaSearch} />
            CONSULTAR
          </Button>
          <Button
            bg={"none"}
            color={BLUEMONEDDBUTTONS}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaFileExport} />
            Exportar Boleto
          </Button>
        </Flex>*/}
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        px={10}
        flexDirection={"column"}
      >
        <Flex
          width={"100%"}
          height={"100%"}
          justifyContent="space-evenly"
          mt={4}
          flexDirection={"column"}
        >
          <Flex py={3} w={"100%"} justifyContent="space-between">
            <Select
              placeholder="Filtrar por Status"
              maxW={"300px"}
              fontSize={"1.8vh"}
              value={filtros.statusFilter}
              onChange={onChangeStatusFilter}
            >
              {statusOptions.map((item) => {
                return (
                  <option value={item.value} key={item.key}>
                    {item.text}
                  </option>
                );
              })}
            </Select>
            {/* <Select
              placeholder="Filtrar por Tipo de Venda"
              maxW={"300px"}
              value={filtros.saleTypeFilter}
              onChange={onChangeModoPgtoFilter}
            >
              {modoPgtoOptions.map((item) => {
                return (
                  <option value={item.value} key={item.key}>
                    {item.text}
                  </option>
                );
              })}
            </Select> */}
            <DateDropdownDeafult filtros={filtros} setFiltros={setFiltros} />
            {/* <ValueDropdown filtros={filtros} setFiltros={setFiltros} /> */}
            {/* <Button
              bg={"none"}
              color={BLUEMONEDDBUTTONS}
              isDisabled={loading || dias}
              onClick={() => {
                Export();
              }}
              mx="10px"
              isLoading={loading}
              textTransform={"uppercase"}
              leftIcon={<FaFileExport />}
            >
              <Text fontSize={"0.8rem"}>Exporte o seu relatório</Text>
            </Button> */}
            <Button
              bgColor={GRAY_DARK}
              color={WHITE}
              fontSize={"1.8vh"}
              onClick={() => {
                setFiltros(initialValues);
              }}
            >
              Limpar Filtros
            </Button>
            <Button
              bgColor={BLUEMONEDDBUTTONS}
              color={WHITE}
              fontSize={"1.8vh"}
              onClick={() => {
                goToAddVendaBoleto(navigate);
              }}
              fontWeight={"bold"}
            >
              <Icon mr={2} as={FaPlus} />
              NOVA VENDA BOLETO
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Box width={"100%"} height={"85%"} mt={"0.1%"} mx="auto" py={3} px={10}>
        {loading ? (
          <Flex
            w={"100%"}
            // h={"66vh"}
            alignItems={"center"}
            justifyContent={"center"}
            px={4}
            flexDirection="column"
          >
            <Spinner size={"lg"} color={VARIANT} />
          </Flex>
        ) : (
          <TableContainer borderRadius="8px">
            <Table variant="striped" size="sm" overflowY="scroll">
              <Thead h="50px" position="sticky" top="0">
                <Tr>
                  <Th
                    borderRadius={"8px 0px 0px 8px"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Data
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    EC
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Status
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Pagador
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Vencimento
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Data de Pagamento
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Valor Total
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    %Taxa
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Valor Tarifa
                  </Th>
                  <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                    Valor Liquido
                  </Th>
                  {/* <Th bgColor={VARIANT} color={WHITE}>
                                    Estabelecimento
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    ID de transação
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    Tipo de Venda
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    Valor
                                </Th> */}
                  <Th
                    borderRadius={"0px 8px 8px 0px"}
                    bgColor={BLUEMONEDDBUTTONS}
                    color={WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        // cursor="pointer"
                        // onClick={() => {
                        //   setIsOpen(true);
                        //   setItemDetails(item);
                        // }}
                      >
                        <Td borderRadius={"8px 0px 0px 8px"}>
                          {moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")}
                        </Td>
                        <Td whiteSpace={"normal"}>
                          {item.isCnpj === true
                            ? item.razaoSocial
                            : `${item.razaoSocial} ${item.nomeFantasia}`}
                        </Td>
                        <Td>
                          <Flex flexDirection={"row"}>
                            {(item.status === "succeeded" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"green"} />{" "}
                                Sucesso
                              </>
                            )) ||
                              (item.status === "pending" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"yellow"} />{" "}
                                  Pendente
                                </>
                              )) ||
                              (item.status === "failed" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"orange"} />{" "}
                                  Falhou
                                </>
                              )) ||
                              (item.status === "new" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"gray"} />{" "}
                                  Nova
                                </>
                              )) ||
                              (item.status === "chargeback" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"purple"} />{" "}
                                  ChargeBack{" "}
                                </>
                              )) ||
                              (item.status === "canceled" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"red"} />{" "}
                                  Cancelado{" "}
                                </>
                              ))}
                          </Flex>
                        </Td>
                        <Td>{item.clienteNome}</Td>
                        <Td>
                          {item.dataExpiracao
                            ? moment(item.dataExpiracao).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "- -"}
                        </Td>
                        <Td>
                          {item.dataPagamento
                            ? moment(item.dataPagamento).format("DD/MM/YYYY")
                            : "- -"}
                        </Td>
                        <Td>
                          {item.valor
                            ? item.valor.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "R$ 0,00"}
                        </Td>
                        <Td>
                          {item.taxaPlano ? `${item.taxaPlano} %` : "0 %"}
                        </Td>
                        <Td>
                          {item.taxaCliente
                            ? item.taxaCliente.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "R$ 0,00"}
                        </Td>
                        <Td>
                          {item.valorLiquido
                            ? item.valorLiquido.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : item.valorLiquido}
                        </Td>
                        {/* <Th>{item.clienteNome}</Th>
                                            <Th>{item.idTransacao}</Th>
                                            <Th w={"fit-content"}>
                                                <CardImageList key={index} text={item.bandeiraCartao}>
                                                    {item.bandeiraCartao}
                                                </CardImageList>
                                            </Th>
                                            <Th>{item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</Th> */}
                        {/* <Th>
                                                <Flex
                                                    w={"100%"}
                                                    cursor="pointer"
                                                    onClick={() => {
                                                        setIsOpen(true);
                                                        
                                                    }}
                                                >
                                                    <Icon mr={2} as={FaEye} /> <Text>Detalhes</Text>
                                                </Flex>
                                            </Th> */}
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={BLUEMONEDDBUTTONS}
                              color={WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              <MenuItem
                                icon={<FaPlus />}
                                onClick={() => {
                                  setOpenDetails(true);
                                  setDetails(item);
                                }}
                              >
                                Visualizar Detalhes
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        )}
        <ModalSalesListDetail
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          item={itemDetails}
        />
        <ModalDetailVendaBoleto
          isOpen={openDetails}
          setIsOpen={setOpenDetails}
          item={details}
        />
        <Flex width={"100%"} justifyContent="center" mt={8}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            ml={5}
            maxW="70px"
            borderRadius="6px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
      </Box>
    </Flex>
  );
}
